import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreatePlannerActions as Actions,
  CreatePlannerRequestAction as RequestAction,
} from 'store/ducks/planners';

export function* createPlannerRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `auth/register/planner`, postData);
    onSuccess && onSuccess();
    notify('success', 'Planejador criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
